import styled from '@emotion/styled';
import { Alert, AlertTitle, Box, Divider, Grid, Paper, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux';

export const DetalleDocumentos = () => {



  const Item = styled(Paper)(({ theme }:any) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
  }));


  return (
    <>
       <Alert severity="info">
          <AlertTitle>Info</AlertTitle>
          Aquí podrás descargar copia de los documentos escaneados de los colaboradores de tu organización, 
          solo presiona descargar en el botón del documento correspondiente y revisa en tu carpeta de descargas.
        </Alert>


        <Grid container  sx={{ marginTop: 3,justifyContent: 'space-between' }}>



          {/* *********** */}
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} >Tipo de documento </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Descargar Archivos</Typography>
              </Box>
            </Grid>
        {/* ********** */}


          

        </Grid>


        <Grid container  sx={{ marginTop: 3,justifyContent: 'space-between' }}>

          {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Cedula </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Icon Cedula </Typography>
              </Box>
            </Grid>
        {/* ********** */}


        </Grid>
        <Divider/>

        <Grid container  sx={{ marginTop: 3,justifyContent: 'space-between' }}>

          {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Hoja de vida </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Icon HV </Typography>
              </Box>
            </Grid>
        {/* ********** */}

        </Grid>
        <Divider/>
        

        <Grid container  sx={{ marginTop: 5,justifyContent: 'space-between' }}>

          {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Ingreso </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > &nbsp;</Typography>
              </Box>
            </Grid>
        {/* ********** */}

        </Grid>


        <Grid container  sx={{ marginTop: 3,justifyContent: 'space-between' }}>

          {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Visita Domiciliaria </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Icon vd</Typography>
              </Box>
            </Grid>
        {/* ********** */}

        </Grid>
        <Divider/>




        <Grid container  sx={{ marginTop: 3,justifyContent: 'space-between' }}>


          {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Prueba Psicotecnica </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Icon ppsi</Typography>
              </Box>
            </Grid>
        {/* ********** */}

          

        </Grid>
        <Divider/>




        <Grid container  sx={{ marginTop: 5,justifyContent: 'space-between' }}>

          {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Examenes </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > &nbsp;</Typography>
              </Box>
            </Grid>
        {/* ********** */}

        </Grid>


        <Grid container  sx={{ marginTop: 3,justifyContent: 'space-between' }}>

          {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Examenes Ingreso </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Icon EXi</Typography>
              </Box>
            </Grid>
        {/* ********** */}

        </Grid>
        <Divider/>




        <Grid container  sx={{ marginTop: 5,justifyContent: 'space-between' }}>

          {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Contrato </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > &nbsp;</Typography>
              </Box>
            </Grid>
        {/* ********** */}

        </Grid>


        <Grid container  sx={{ marginTop: 3,justifyContent: 'space-between' }}>

          {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Deberia ser contrato </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Icon contra</Typography>
              </Box>
            </Grid>
        {/* ********** */}

        </Grid>
        <Divider/>


        

    </>
  )
}
